import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, isMobile) {
    gaService.send('games', 'boldplay', gameId);
    return (await Vue.http.post('/api/boldplay/session/open', { gameId, language, isMobile })).data;
  },
  async openDemoSession(gameId, language, isMobile) {
    gaService.send('games-demo', 'boldplay', gameId);
    return (await Vue.http.post('/api/boldplay/session/opendemo', { gameId, language, isMobile })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/boldplay/session/close')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/boldplay.service.js